export const formatCustomerDateTime = (value) => {
  const date = new Date(value);
  if (!Number.isFinite(date.getTime())) return "מועד לא תקין";
  const parts = Object.fromEntries(new Intl.DateTimeFormat("en-GB", {
    timeZone: "Asia/Jerusalem",
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hourCycle: "h23",
  }).formatToParts(date).filter((part) => part.type !== "literal").map((part) => [part.type, part.value]));
  const weekday = new Intl.DateTimeFormat("he-IL", {
    timeZone: "Asia/Jerusalem",
    weekday: "long",
  }).format(date);
  return `${weekday}, ${parts.day}.${parts.month}.${parts.year} בשעה ${parts.hour}:${parts.minute}`;
};
